@if ((isOnline$ | async) === false) {
  <div style="background-color: #d32f2f; color: white; display: flex; align-items: center; justify-content: center; padding: 10px 15px; font-weight: 500; font-size: 14px; gap: 10px; z-index: 1000; position: sticky; top: 0; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)">
    <mat-icon style="vertical-align: middle">cloud_off</mat-icon>
    <span>Connexion au serveur perdue. Reconnexion automatique en cours...</span>
  </div>
}

@if (false && showNavbar) {
  <app-menu-common url="home"></app-menu-common>
}
<app-alert></app-alert>
<app-spinner></app-spinner>
<router-outlet></router-outlet>
<div class="flexrow app-footer">
  <!-- Admin : lien vers /server_info dans un nouvel onglet, pour ne jamais quitter une saisie en cours ; texte simple pour les autres (la page leur est refusée). -->
  @if (isAdmin()) {
    <a class="app-footer-link" routerLink="/server_info" target="_blank" title="Informations du serveur">v{{ appVersion }} (fselib v{{ fselibVersion }})@if (serverVersion()) {&nbsp;· serveur v{{ serverVersion() }}}</a>
  } @else {
    <div>v{{ appVersion }} (fselib v{{ fselibVersion }})@if (serverVersion()) {&nbsp;· serveur v{{ serverVersion() }}}</div>
  }
  <div class="spacer"></div>
  @if (loginService.currentstation) {
    <div>Station :&nbsp;{{ loginService.currentstation.name }}&nbsp;({{ loginService.currentstation.lnk_store.name }})</div>
  }
</div>
